// src/AudioSpectrum/effects/spectrogram.js
import { getColor } from '../colorUtils.js';

export const drawSpectrogram = (ctx, frequencyData, width, height, spectrogramData) => {
  spectrogramData.current.unshift([...frequencyData.slice(0, height)]);
  
  if (spectrogramData.current.length > width) {
    spectrogramData.current = spectrogramData.current.slice(0, width);
  }
  
  ctx.clearRect(0, 0, width, height);
  
  const imageData = ctx.createImageData(width, height);
  const data = imageData.data;
  
  for (let x = 0; x < Math.min(width, spectrogramData.current.length); x++) {
    const spectrum = spectrogramData.current[x];
    for (let y = 0; y < height; y++) {
      const spectrumIndex = Math.floor((y / height) * spectrum.length);
      const value = spectrum[spectrumIndex] || 0;
      
      const pixelIndex = (y * width + x) * 4;
      const color = getColor(value);
      const rgb = color.match(/\d+/g);
      
      data[pixelIndex] = parseInt(rgb[0]);
      data[pixelIndex + 1] = parseInt(rgb[1]);
      data[pixelIndex + 2] = parseInt(rgb[2]);
      data[pixelIndex + 3] = 255;
    }
  }
  
  ctx.putImageData(imageData, 0, 0);
};